<template>
    <div>
        <h1>Medlemsbetalinger</h1>
        <v-data-table
            :headers="headers"
            :items="betalinger"
            sort-by="due"
            :sort-desc="true"
            v-if="betalinger"
        >
            <template v-slot:item.amount="{ item }">
                {{ item.amount / 100 }}
            </template>
        </v-data-table>
        <v-alert
            v-else-if="error"
            type="error"
        >
            {{ error }}
        </v-alert>
        <v-progress-circular
            v-else
            indeterminate
            color="primary"
        ></v-progress-circular>
    </div>
</template>

<script>
import MedlemsService from '@/services/MedlemsService'

export default {
  name: 'MedlemsBetalinger',
  props: {
    memberId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      betalinger: null,
      error: null,
      headers: [
        { text: 'Dato', value: 'due' },
        { text: 'Beløb', value: 'amount' },
        { text: 'Status', value: 'status' },
        { text: 'Type', value: 'type' }
      ]
    }
  },
  watch: {
    memberId: {
      immediate: true,
      handler () {
        this.fetchBetalinger()
      }
    }
  },
  methods: {
    async fetchBetalinger () {
      try {
        this.error = null
        const response = await MedlemsService.getBetalinger(this.memberId)
        this.betalinger = response.data
      } catch (error) {
        this.error = 'Kunne ikke hente betalinger'
        console.error('Error fetching payments:', error)
      }
    }
  }
}
</script>
